import React from "react"
import autobind from "class-autobind"
import TimelineTable from "../../../../components/schedule/daily_timeline/TimelineTable"
import { ISchedulePatternTemplate, IScheduleDailyTimelineData, ISchedulePatternTemplateItemWithQty } from "../../../../models"
import strings from "../../../../localization/strings"
import AccountStore from "../../../../stores/AccountStore"
import AppStateStore from "../../../../stores/AppStateStore"
import * as utils from "../../../../helpers/utils"
import * as timeHelper from "../../../../helpers/timeHelper"
import { Table, TableBody, TableRow, TableRowColumn } from "material-ui"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import TableActionBar from "../../../../components/layout/TableActionBar"
import ConfirmDialog from "../../../../components/common/ConfirmDialog"
import EditPatternTemplateQtyDialog from "./EditPatternTemplateQtyDialog"
interface IProps {
	patternTemplates: ISchedulePatternTemplate[]
	handleDeletePatternTemplates(patternTemplates: ISchedulePatternTemplate[]): void
	handleUpdatePatternTemplateQty(newPatternTemplate: ISchedulePatternTemplate, quantity: number): void
	handleUpdateUniquePatternTemplate(uniquePatternTemplate: ISchedulePatternTemplate): void
}
interface IState {
	width: number
	patternTemplates: ISchedulePatternTemplate[]
	searchText: string
	selectedPatternTemplates: ISchedulePatternTemplate[]
	confirmDialogContent: string
	confirmDialogPayload?: any
	editPatternTemplateWithQty: ISchedulePatternTemplateItemWithQty
}

export default class ScheduleTemplateTimeinfoDetailDayView extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			width: 1200,
			patternTemplates: props.patternTemplates,
			searchText: "",
			selectedPatternTemplates: [],
			confirmDialogContent: "",
			editPatternTemplateWithQty: null,
		}
		autobind(this)
	}

	componentDidMount() {
		this.updateDimensions()
		window.addEventListener("resize", this.updateDimensions)
		AppStateStore.on("change", this.updateDimensions)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			selectedPatternTemplates: [],
			patternTemplates: nextProps.patternTemplates.filter(pt => this.state.searchText ? pt.Name.toLocaleLowerCase().includes(this.state.searchText.toLocaleLowerCase()) : true),
		})
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions)
		AppStateStore.removeListener("change", this.updateDimensions)
	}

	updateDimensions() {
		const scheduleTemplateTimeInfoDetailDom = document.getElementById("ScheduleTemplateTimeInfoDetail")
		const width = scheduleTemplateTimeInfoDetailDom.offsetWidth - Number(scheduleTemplateTimeInfoDetailDom.style.paddingLeft.replace("px", "")) - Number(scheduleTemplateTimeInfoDetailDom.style.paddingRight.replace("px", ""))
		this.setState({ width })
	}

	getIimelineItemRenderElement(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number) {
		const timelineItemData = this.getUniquePatternTemplateWithQty(this.state.patternTemplates)[rowNumber].patternTemplate.ShiftTemplates[orderNumber]
		const position = AccountStore.getCurrentAccount().PositionDefinitions.find((item) => item.Id === timelineItemData.PositionId)
		const timeInfo = `${timeHelper.getTimeStringSimpleFormatFromSimpleTime(timelineItem.StartTime)}-${timeHelper.getTimeStringSimpleFormatFromSimpleTime(timelineItem.EndTime)}`
		const backgroundColor = position && position.Color ? position.Color : AccountStore.getPositionDefaultColor()
		return (
			<div style={{ backgroundColor, height: 46, textAlign: "center", display: "flex" }}>
				<div style={{ flex: 0.2 }} />
				<div style={{ color: "white", flex: 1, paddingTop: 13 }} className="TextOverflow" title={timeInfo}>
					{timeInfo}
				</div>
				<div style={{ flex: 0.1 }} />
				<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", flex: 1, height: 30, marginTop: 8, fontSize: 15, borderRadius: 15, backgroundColor: utils.getMaterial900ColorFrom500Color(backgroundColor), color: "rgba(254, 254, 254, 0.5)" }}>
					<div style={{ marginTop: 5, paddingLeft: 5, paddingRight: 5 }} title={timelineItemData.Name} className="TextOverflow">
						{timelineItemData.Name}
					</div>
				</div>
				<div style={{ flex: 0.2 }} />
			</div>
		)
	}

	getUniquePatternTemplateWithQty(patternTemplates: ISchedulePatternTemplate[]): ISchedulePatternTemplateItemWithQty[] {
		const uniquePatternTemplatesWithQty: ISchedulePatternTemplateItemWithQty[] = []
		const uniquePatternTemplates: ISchedulePatternTemplate[] = []
		patternTemplates.forEach((patternTemplate) =>
			!uniquePatternTemplates.find((exitElem) => exitElem.Id === patternTemplate.Id) && uniquePatternTemplates.push(patternTemplate)
		)
		uniquePatternTemplates.forEach((uniItem) => {
			const quantity = patternTemplates.filter((ptItem) => {
				return ptItem.Id === uniItem.Id
			}).length
			uniquePatternTemplatesWithQty.push({ patternTemplate: uniItem, quantity })
		})
		return uniquePatternTemplatesWithQty.sort((a, b) => {
			const name1 = a.patternTemplate.Name.toLowerCase()
			const name2 = b.patternTemplate.Name.toLowerCase()
			if (name1 < name2) return -1
			if (name1 > name2) return 1
			return 0
		})
	}

	render() {
		const uniquePatternTemplatesWithQty = this.getUniquePatternTemplateWithQty(this.state.patternTemplates)
		const timelineData: IScheduleDailyTimelineData[][] = new Array(uniquePatternTemplatesWithQty.length)
		uniquePatternTemplatesWithQty.forEach((uniqItem, index) => {
			const dailyTimelineData: IScheduleDailyTimelineData[] = []
			uniqItem.patternTemplate.ShiftTemplates.forEach((shiftTemplate) => {
				dailyTimelineData.push({ StartTime: shiftTemplate.StartTime, EndTime: shiftTemplate.EndTime, Breaks: shiftTemplate.Breaks })
			})
			timelineData[index] = dailyTimelineData
		})
		return (
			<div style={{ marginTop: 25, marginBottom: 15 }}>
				<TableActionBar
					rowSelectionCount={this.state.selectedPatternTemplates.length}
					singleSelectedMessage={strings.Shift_Selected}
					multipleSelectedMessage={strings.x_Shifts_Selected}
					title={strings.Shifts}
					onSearch={searchText => this.setState({
						searchText,
						patternTemplates: this.props.patternTemplates.filter(pt => searchText ? pt.Name.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()) : true)
					})}
					searchText={this.state.searchText}
					onDeleteClick={() => this.setState({
						confirmDialogContent: strings.Are_you_sure_you_want_to_delete_the_selected_shift,
						confirmDialogPayload: this.state.selectedPatternTemplates
					})}
					readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.DeleteAccountSchedule)}
					onCloseSearchClick={() => this.setState({ searchText: "", selectedPatternTemplates: [] })}
				/>
				{this.state.patternTemplates.length === 0 ?
					<Table>
						<TableBody displayRowCheckbox={false}>
							<TableRow>
								<TableRowColumn>
									<h2 style={{ textAlign: "center", marginTop: 25 }}>
										{strings.No_shift_found}
									</h2>
								</TableRowColumn>
							</TableRow>
						</TableBody>
					</Table> :
					<div style={{ marginTop: 10 }}>
						<TimelineTable
							items={uniquePatternTemplatesWithQty}
							timelineData={timelineData}
							timelineItemRenderElement={this.getIimelineItemRenderElement}
							leftSideColumns={[
								{
									HeaderLabel: strings.Name,
									HeaderStyle: { textAlign: "center" },
									Col: (row) =>
										<div className="TextOverflow" title={row.patternTemplate.Name}>{row.patternTemplate.Name}</div>,
									ColStyle: { textAlign: "left", cursor: "default", paddingLeft: 0, paddingRight: 0 }
								},
								{
									HeaderLabel: strings.Qty,
									HeaderStyle: { textAlign: "center" },
									Col: (row) =>
										<span>{row.quantity}</span>,
									ColStyle: { textAlign: "center", cursor: "default", paddingLeft: 0, paddingRight: 0 }
								}
							]}
							referenceFieldNameToIdentifyPatternTemplate="patternTemplate"
							multiSelectable={permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
							selectable={permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
							selectIdentityPropertyNames={["patternTemplate", "Id"]}
							readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule)}
							timelineTableWidth={this.state.width}
							leftSideWidth={300}
							handleSelect={(selectedPatternTemplatesWithQty: ISchedulePatternTemplateItemWithQty[]) =>
								this.setState({ selectedPatternTemplates: selectedPatternTemplatesWithQty.map(item => item.patternTemplate) })
							}
							handleUpdate={editPatternTemplateWithQty => permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule) &&
								this.setState({ editPatternTemplateWithQty })
							}
							handleUpdateTimelineItem={(item, rowNumber, orderNumber) => {
								const uniquePatterTemplate = uniquePatternTemplatesWithQty[rowNumber].patternTemplate
								uniquePatterTemplate.ShiftTemplates[orderNumber] = item
								this.props.handleUpdateUniquePatternTemplate(uniquePatterTemplate)
							}}
							handleUpdateTimelineData={(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number) => {
								const uniquePatterTemplate = uniquePatternTemplatesWithQty[rowNumber].patternTemplate
								uniquePatterTemplate.ShiftTemplates[orderNumber].StartTime = timelineItem.StartTime
								uniquePatterTemplate.ShiftTemplates[orderNumber].EndTime = timelineItem.EndTime
								this.props.handleUpdateUniquePatternTemplate(uniquePatterTemplate)
							}}
							handleDeleteTimelineItem={(rowNumber, orderNumber) => {
								const uniquePatterTemplate = uniquePatternTemplatesWithQty[rowNumber].patternTemplate
								this.props.handleDeletePatternTemplates([uniquePatterTemplate])
							}}
						/>
					</div>
				}
				{this.state.confirmDialogContent &&
					<ConfirmDialog
						open
						confirmContent={this.state.confirmDialogContent}
						payload={this.state.confirmDialogPayload}
						close={() => this.setState({ confirmDialogContent: "", confirmDialogPayload: null })}
						confirm={(action, payload) => {
							this.setState({ confirmDialogContent: "", confirmDialogPayload: null, selectedPatternTemplates: [] })
							this.props.handleDeletePatternTemplates(payload)
						}}
					/>
				}
				{this.state.editPatternTemplateWithQty &&
					<EditPatternTemplateQtyDialog
						editPatternTemplateWithQty={this.state.editPatternTemplateWithQty}
						handleClose={() => this.setState({ editPatternTemplateWithQty: null })}
						handleUpdatePatternTemplateQty={(patternTemplate, quantity) => {
							this.setState({ editPatternTemplateWithQty: null })
							this.props.handleUpdatePatternTemplateQty(patternTemplate, quantity)
						}}
					/>
				}
			</div>
		)
	}
}